import React from 'react'
import { Flex } from 'hljd'
import SubView from '../SubView'
import style from './style.module.less'

function View(props) {
  const { title, extra, children } = props
  return (
    <Flex className={style.view} d="v">
      {title && (
        <Flex className={style.header} vc sp>
          <Flex className={style.title} vc>
            {title}
          </Flex>

          {extra && <div className={style.extra}>{extra}</div>}
        </Flex>
      )}

      <div className={style.content}>{children}</div>
    </Flex>
  )
}

View.Sub = SubView

export default View
